var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.modal)?_c('el-dialog',{staticClass:"dialog",attrs:{"visible":_vm.modal,"closeOnClickModal":false},on:{"update:visible":function($event){_vm.modal=$event}}},[(!_vm.isForget)?_c('login',{attrs:{"islogin":_vm.isLogin},on:{"login":_vm.login,"forget":_vm.forget}}):_c('forget',{attrs:{"mobile":_vm.phone},on:{"forget":_vm.forget}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7926685e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/login/loginDialog.vue
// module id = null
// module chunks = 